import React from 'react';
import { useDispatch } from "react-redux"
import { Modal, Button, Alert } from "components/common"
import { toast } from "react-toastify"
import { FaTrash } from "react-icons/fa"
import { deleteForever } from "redux/drive/driveSlice"
import PropTypes from 'prop-types';

const DriveDeleteForeverConfirm = ({ showModal, setshowModal, asset }) => {
  const assetId = asset.id;
  const dispatch = useDispatch();

  const closeModal = () => {
    setshowModal(false);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      dispatch(deleteForever(assetId));
      closeModal();
    }
    catch (error) {
      toast.error(error.message);
    }
  }

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      title="Delete forever confirmation!"
      backdropClick={false}
      footer={(
        <>
          <Button size="sm" type="submit" variant="warning" form="drive-delete-forever-form"><FaTrash /> Delete forever</Button>
          <Button size="sm" variant="danger" onClick={closeModal}>Cancel</Button>
        </>
      )}
    >
      <form id="drive-delete-forever-form" onSubmit={handleSubmit}>
        <Alert type="warning">
          Area you sure to delete forever {asset?.asset_type} <strong>{asset?.name}</strong>?
        </Alert>
      </form>
    </Modal>
  )
};

DriveDeleteForeverConfirm.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  asset: PropTypes.shape({
    id: PropTypes.string.isRequired,
    asset_type: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
};


export default DriveDeleteForeverConfirm;
